import {Tooltip} from "@mui/material";
import React from "react";
import {useStores} from "../../../../../../stores";
import CircularProgress from "@mui/material/CircularProgress";
import {observer} from "mobx-react-lite";

export const ToolbarLoadingIndicator: React.FC = observer(() => {
    const {categorizationReviewStore} = useStores()
    if (categorizationReviewStore.reviewPageController.reviewApi.nInPipe === 0) return null;
    return <>
        <Tooltip title={`Loading ${categorizationReviewStore.reviewPageController.reviewApi.nInPipe} requests...`}>
            <span>
                <CircularProgress size={14}/>
            </span>
        </Tooltip>
    </>
})
